import React from 'react';
import css from '@styled-system/css';
import { Box, Alert } from '@honda-canada/design-system-react';
import styled from 'styled-components';

import AnotherBrandNotification from './AnotherBrandNotification';
import ResponseMessageText from './ResponseMessageText';
import ResponseMessagePropTypes from './IResponseMessage';
import getStyleVariant from './utils/getStyleVariant';

const ResponseMessageContainer = styled(Box)(
  css({
    margin: ['45px auto 0 auto', '30px auto 0 auto'],
    maxWidth: '612px',
  }),
);

const ResponseMessage = ({
  messageText,
  hasOutstandingCampaigns,
  hasCompletedCampaigns,
  productLine,
  productLink,
  isCrossBrandMsg,
  isVinValid,
}) => {
  const { alertVariant, textColor } = getStyleVariant(
    hasCompletedCampaigns,
    hasOutstandingCampaigns,
    isCrossBrandMsg,
    isVinValid,
  );

  const alertMessageContent = isCrossBrandMsg ? (
    <AnotherBrandNotification copyColor={textColor} productLink={productLink} productLine={productLine} />
  ) : (
    <ResponseMessageText copyColor={textColor} messageText={messageText} />
  );
  return (
    <ResponseMessageContainer>
      <Alert variant={alertVariant} dataTestId={`dsr-alert-${alertVariant}`}>
        {alertMessageContent}
      </Alert>
    </ResponseMessageContainer>
  );
};

ResponseMessage.propTypes = ResponseMessagePropTypes;

export default ResponseMessage;
